import { push } from 'connected-react-router';
import { getResourceTo } from 'react/utils/utils';

const getFormmatedMenuText = (menu, textToReplace) => {
  const translatedMenu = getResourceTo(menu.name);

  if (menu?.url) {
    const regexExp = new RegExp(textToReplace, 'i');

    return String(translatedMenu).replace(regexExp, (match) => {
      return `<b>${match}</b>`
    });
  }

  return translatedMenu;
};

export const getSafeURL = (urlText) => {
  const parsedURL = urlText.replace('#', '');

  return (parsedURL === '/welcome' ? '/RouteMonitor' : parsedURL);
};

export const isPinned = (menu) => {
  const { getPinnedMenusFromUser } = new Greenmile.Storage.StoreMapPosition();
  const pinnedMenus = getPinnedMenusFromUser();

  return pinnedMenus.find((item) => item.name === menu.name || getSafeURL(item.url) === menu.url);
};

export const getBreadcumbsMenus = ({
  menus,
  textToSearch
}) => {
  const breadCumbListArrayResult = [];

  const getGrandChildrenMenus = ({
    item,
    parent,
    grandParent
  }) => {
    const translatedMenu = getResourceTo(item.name).toLowerCase();
    const parsedTextToMatch = textToSearch.toLowerCase();

    if (translatedMenu.includes(parsedTextToMatch)) {
      const breadCumbList = [
        {
          name: parent.name
        },
        {
          name: item.name,
          url: getSafeURL(item.url)
        }
      ];

      grandParent && breadCumbList.unshift({
        name: grandParent.name
      });

      const parsedBreadCumb = breadCumbList.map(breadCrumb => (
        {
          ...breadCrumb,
          name: getFormmatedMenuText(breadCrumb, textToSearch)
        }
      ));

      return {
        breadCumbs: parsedBreadCumb,
        isPinned: isPinned(item),
        searchedMenu: item.name,
      };
    }
  };

  const getChildrenMenus = (item) => {
    if (item?.submenus) {
      item.submenus.forEach((submenu) => {
        if (submenu?.submenus) {
          submenu.submenus.forEach((subMenuItem) => {
            const breadCumbItem = getGrandChildrenMenus({
              item: subMenuItem,
              parent: submenu,
              grandParent: item
            });

            breadCumbItem && breadCumbListArrayResult.push(breadCumbItem)
          });
        } else {
          const breadCumbItem = getGrandChildrenMenus({
            item: submenu,
            parent: item
          });

          breadCumbItem && breadCumbListArrayResult.push(breadCumbItem)
        }
      });
    }
  };

  return new Promise((resolve, _) => {

    if (!textToSearch?.length || !menus?.length) {
      resolve(breadCumbListArrayResult);
    }

    menus.forEach(getChildrenMenus);

    resolve(breadCumbListArrayResult);
  });
};

export const getMenuAbbreviation = (text) => {
  const lettersOfWords = text.match(/\b[\w]/gm)?.join('') || text.substr(0, 2);

  if (lettersOfWords.length >= 2) {
    const firstLetterOfFirstWorld = lettersOfWords[0];
    const firstLetterOfSecondWorld = lettersOfWords[1];

    return `${firstLetterOfFirstWorld}${firstLetterOfSecondWorld}`;
  } else {
    const splitedText = String(text).split(' ');

    const firstLetterOfFirstWorld = splitedText[0][0];
    const secondLetterOfFirstWorld = splitedText[0][1];

    return `${firstLetterOfFirstWorld}${secondLetterOfFirstWorld}`;
  }
}

export const getShortedRecentMenus = (recentMenus) => {
  return recentMenus.map((item) => {
    const translatedMenu = getResourceTo(item.name);

    return {
      ...item,
      abbreviation: getMenuAbbreviation(translatedMenu)
    };
  });
}

export const getClusterMenusName = (menu) => {
  switch (menu) {
    case 'VehiclesTracker':
      return getResourceTo('topMenuSeparator.monitoring');
    case 'topMenu.dashboards':
      return getResourceTo('topMenu.analytics');
    case 'topMenu.organization':
      return getResourceTo('topMenu.security');
    case 'topMenu.autoArriveConfiguration':
      return getResourceTo('topMenu.autoArrive');
    case 'topMenu.user':
      return getResourceTo('topMenu.securityMenu');
    case 'topMenu.proactiveRouteOptConfig':
      return getResourceTo('topMenuSeparator.PROAndMobileApps');
    case 'topMenu.dashboards.geotab':
      return getResourceTo('topMenuSeparator.partnerIntegrations');
    case 'topMenu.descartesIntegrations':
      return getResourceTo('topMenu.descartesIntegrations');
    default:
      return null;
  }
};

export const navigateToUrl = (url) => {
  const parsedUrl = getSafeURL(url);

  window.globalStore.dispatch(push(parsedUrl));
}

export function isAbleToHoverQuickly(e) {
  const classList = e.target.classList;

  return classList.contains('search-container') ||
    classList.contains('pinneds-container') ||
    classList.contains('divider');
}

export function setDefaultPinnedMenu(menus) {
  const storagePosition = new Greenmile.Storage.StoreMapPosition();
  const routeSummaryMenu = menus
    .find((menu) => menu.name === 'topMenu.dispatchingLive')
    ?.submenus
    .find((menu) => menu.name === 'topMenu.routeMonitor');

  if (routeSummaryMenu) {
    storagePosition.setPinnedMenusFromUser([routeSummaryMenu]);

    return [routeSummaryMenu];
  }

  return [];
}
